<template lang="pug">
  .container-restrictions(v-if='playParams', id="MediumPlayProperties-container")
    .row
      .header
        p {{$t('Duration:')}}
      el-radio-group(v-model='durationStrategy', size="mini")
        el-radio-button(id="MediumPlayProperties-durationNaturalButton" label='Natural')
          span {{ $t('Natural') }} &nbsp;
          font-awesome-icon(icon="clock")
        el-radio-button(id="MediumPlayProperties-durationForcedButton" label='Forced')
          span {{ $t('Forced') }} &nbsp;
          font-awesome-icon(icon="ruler-horizontal")
      span &nbsp; ({{ msToDuration(naturalDurationMs) }} {{$t('natural duration')}})
    .row
      .header &nbsp;
      DurationInput(
        id="PlayListItemPlayProperties-durationInput",
        :disabled='!(durationStrategy === "Forced")',
        :durationMs='playParams.playDurationMs',
        @durationUpdated='updatePlayItemDuration'
      )
    .row
      .header
        p {{$t('After end:')}}
        p {{$t('(if forced duration is longer than natural)')}}
      el-radio-group(
        v-model='playParams.onEndBehaviour',
        :disabled='!(playParams.playDurationMs > naturalDurationMs)',
        size="mini"
      )
        el-radio-button(label='loop' id="PlayListItemPlayProperties-onEndLoopButton" )
          span {{ $t('Loop') }} &nbsp;
          font-awesome-icon(icon="recycle")
        el-radio-button(label='transparent' id="PlayListItemPlayProperties-onEndStopButton" )
          span {{ $t('Stop') }} &nbsp;
          font-awesome-icon(icon="hand-paper")
      span(v-if='playParams.onEndBehaviour === "transparent"') &nbsp; ({{ msToDuration(playParams.playDurationMs - naturalDurationMs) }}
        span(v-if="medium.type === 'Audio'") {{$t(' of silence') }}
        span(v-if="medium.type !== 'Audio'") {{$t(' of transparency') }}
        span )
      span(v-if='playParams.onEndBehaviour === "loop"') &nbsp; ({{$t('loop')}} {{ parseFloat(playParams.playDurationMs / naturalDurationMs).toFixed(3) }} {{$t(' times') }})
    .row.button
      el-button(
        id="MediumProperties-submitButton",
        type="success",
        size="mini",
        @click="savePlayParams()",
        native-type="submit",
        :disabled='isSaving'
      )
        font-awesome-icon(icon="save")
        span &nbsp; {{ !isSaving ? $t('Set display properties') : $t('saving...')}}
</template>

<script>
import Vue from 'vue'
import mediaUtils from '../Common/mediaUtils.mixin'
import textUtils from '../Common/textUtils.mixin'
import DurationInput from '../Common/DurationInput'

export default {
  components: {
    DurationInput
  },
  props: ['medium'],
  mixins: [mediaUtils, textUtils],
  watch: {
    durationStrategy: async function (newVal, oldVal) {
      if (oldVal !== newVal && newVal === 'Natural') {
        this.playParams.playDurationMs = null
      }
    }
  },
  mounted () {
    this.playParams = {
      playDurationMs: this.durationCalculated(),
      playOffsetMs: this.medium.playOffsetMs,
      objectFit: this.medium.objectFit,
      objectPosition: this.medium.objectPosition,
      onEndBehaviour: this.medium.onEndBehaviour,
      pausePlayOtherContent: this.medium.pausePlayOtherContent,
      objectRotation: this.medium.objectRotation
    }
    if (
      this.playParams.playDurationMs !== this.naturalDurationMs ||
      this.medium.playDurationMs > 0
    ) {
      this.durationStrategy = 'Forced'
    }
  },
  data () {
    return {
      isSaving: false,
      durationStrategy: 'Natural',
      playParams: null
    }
  },
  methods: {
    updatePlayItemDuration (data) {
      this.playParams.playDurationMs = data
    },
    buttonSaveText () {
      if (this.isSaving) return 'saving data...'
      return 'Save play parameters'
    },
    __validateInput () {
      if (this.medium.playDurationMs < 0) return false
      return true
    },
    async savePlayParams () {
      if (!this.__validateInput()) return
      this.isSaving = true
      if (this.playParams.playDurationMs === '' || this.durationStrategy === 'Natural') {
        if (this.medium.type === 'Video') {
          this.playParams.playDurationMs = null
        }
        if (
          this.medium.type === 'Image' ||
          this.medium.type === 'HTML5app' ||
          this.medium.type === 'HTMLzip'
        ) {
          this.playParams.playDurationMs = null
        }
        if (this.medium.type.startsWith('PlayList')) {
          this.playParams.playDurationMs = null
        }
      }
      if (this.playParams.playOffsetMs === '') {
        this.playParams.playOffsetMs = 0
      }
      if (this.playParams.objectRotation === '') {
        this.playParams.objectRotation = 0
      }
      const path = `medium/${this.medium.id}`
      await Vue.axios.patch(path, this.playParams)
      this.isSaving = false
      this.$emit('close')
    },
    durationCalculated () {
      if (this.medium.type === 'Video' || this.medium.type === 'Audio') {
        return this.medium.playDurationMs > 0
          ? this.medium.playDurationMs
          : this.naturalDurationMs
      }
      if (
        this.medium.type === 'Image' ||
        this.medium.type === 'HTML5app' ||
        this.medium.type === 'HTMLzip'
      ) {
        return this.medium.playDurationMs > 0
          ? this.medium.playDurationMs
          : 5000
      }
      if (this.medium.type.startsWith('PlayList')) {
        return this.medium.playDurationMs > 0
          ? this.medium.playDurationMs
          : this.medium.playListDurationMs
      }
    }
  },
  computed: {
    playParamsPlayDurationMsChanged () {
      return (
        this.playParams.playDurationMs !== this.playListItem.playDurationMs
      )
    },
    naturalDurationMs () {
      if (this.medium.type.startsWith('Image')) return 5000
      if (this.medium.type.startsWith('PlayList')) return this.medium.playListDurationMs
      return this.$store.state.File.file_list.find(f => f.id === this.medium.File).originalDurationMs
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.container-restrictions {
  font-size: $--font-size-base;
  margin: auto;
  width: 100%;
  .row {
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    .header {
      font-size: $--font-size-big;
      font-weight: bold;
      width: 300px;
    }
    .human-duration {
      text-align: right;
      font-size: $--font-size-mini;
      color: $--color-text-placeholder;
    }
    .naturalDuration {
      background-color: rgba(#000, 0);
      border: 0px;
    }
    &.button {
      // width: 100%;
      justify-content: flex-end;
    }
  }
  .icon {
    color: $--color-text-regular;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Medium/MediumPlayProperties.vue